__turbopack_context__.v({
  "floating": "Marquee-module-scss-module__WdHkwq__floating",
  "marquee": "Marquee-module-scss-module__WdHkwq__marquee",
  "marquee__content": "Marquee-module-scss-module__WdHkwq__marquee__content",
  "marquee__item": "Marquee-module-scss-module__WdHkwq__marquee__item",
  "marquee__logo": "Marquee-module-scss-module__WdHkwq__marquee__logo",
  "marquee__track": "Marquee-module-scss-module__WdHkwq__marquee__track",
  "marquee__track--reverse": "Marquee-module-scss-module__WdHkwq__marquee__track--reverse",
  "rotate": "Marquee-module-scss-module__WdHkwq__rotate",
  "scroll": "Marquee-module-scss-module__WdHkwq__scroll",
});
